import { useEffect, useState } from "react"

import { useLazyGetInstallTrendsWidgetQuery } from "store/api/adminApi"

import WidgetsLayout from "layouts/WidgetsLayout"
import { calculateLastDays } from "layouts/WidgetsLayout/WidgetHeader"

import WidgetContent from "./WidgetContent"

const InstallationTrendsWidget = () => {
  const [selectedDateRange, setSelectedDateRange] = useState(calculateLastDays(7))
  const [triggerGetInstallTrendsWidget, { isFetching, data }] = useLazyGetInstallTrendsWidgetQuery()

  const contentDate = data
    ? [
        {
          title: "Installed Devices",
          value: data.installed_devices,
        },
        {
          title: "Purchased Devices",
          value: data.purchased_devices,
        },
      ]
    : []

  useEffect(() => {
    const fetchData = async () => {
      try {
        await triggerGetInstallTrendsWidget(
          {
            start_date: selectedDateRange[0],
            end_date: selectedDateRange[1],
          },
          true,
        )
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [selectedDateRange])

  return (
    <WidgetsLayout title="Installation trends" onSelectDateRange={setSelectedDateRange}>
      <WidgetContent isFetching={isFetching} data={contentDate} />
    </WidgetsLayout>
  )
}

export default InstallationTrendsWidget
